import moment, { Moment } from 'moment/moment'

export interface ClubAthletePayload {
    id: number
    name: string
    title: string
    photo_url: string
    link: string
    link_text: string
    link_params?: {}
    gold_count: number
    silver_count: number
    bronze_count: number
    metadata?: {}
    status: string
    created_at: string
    translations?: {}
}

export class ClubAthlete {

    id: number
    name: string
    title: string
    photoUrl: string
    photo?: File
    link: string
    linkText: string
    linkParams?: {} = <any>{}
    goldCount: number
    silverCount: number
    bronzeCount: number
    metadata?: {} = <any>{}
    status: string
    createdAt: Moment
    translations?: {} = <any>{}

    constructor(data: ClubAthletePayload) {
        this.id = data.id
        this.name = data.name
        this.title = data.title
        this.photoUrl = data.photo_url
        this.link = data.link
        this.linkText = data.link_text
        this.goldCount = data.gold_count
        this.silverCount = data.silver_count
        this.bronzeCount = data.bronze_count
        this.status = data.status
        this.createdAt = moment(data.created_at)
        this.capture(data)
    }

    fill(data: ClubAthletePayload): this {
        this.id = data.id
        this.name = data.name
        this.title = data.title
        this.photoUrl = data.photo_url
        this.link = data.link
        this.linkText = data.link_text
        this.goldCount = data.gold_count
        this.silverCount = data.silver_count
        this.bronzeCount = data.bronze_count
        this.status = data.status
        this.createdAt = moment(data.created_at)
        this.capture(data)
        return this
    }

    capture(data: ClubAthletePayload): this {
        if (data.link_params) {
            this.linkParams = data.link_params
        }
        if (data.metadata) {
            this.metadata = data.metadata
        }
        if (data.translations) {
            this.translations = data.translations
        }
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
        this.photo = undefined
        this.linkParams = {}
        this.metadata = {}
        this.translations = {}
    }

    payload(): ClubAthletePayload | any {
        return {
            id: this.id,
            name: this.name,
            title: this.title,
            link: this.link,
            link_text: this.linkText,
            link_params: this.linkParams,
            gold_count: this.goldCount,
            silver_count: this.silverCount,
            bronze_count: this.bronzeCount,
            metadata: this.metadata,
            status: this.status,
            translations: this.translations,
        }
    }
}
